export default __webpack_public_path__ + "static/N0079-88ab7c2c9791fb7efa8af6b88d4d0b00.png";